import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SignupService } from '@app-services/signup/signup.service';
import { LoginService } from '@app-services/login/login.service';
import { environment } from '@app-environments/environment';
import { UserService } from '@app-services/user/user.service';
import { Location } from '@angular/common';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TermsAndConditionsDialogComponent } from '@app-shared/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { PrivacyPolicyComponent } from '@app-shared/components/privacy-policy/privacy-policy.component';
import { RegisterDialogComponent } from '@app-shared/components/register-dialog/register-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { allowedExamNamesILITE, allowedGrades, homeRoute,apisDataCacheKeys, curTenantDetails, ISDCodes, INDIAN_ISD_CODE, NEPAL_ISD_CODE } from '@app-constants/app.constants';
import { AuthService } from '@app-services/auth-service/auth.service';
import { clearLocalStorage, getILCookie, setILCookie, setLoggedInUserData, getIpAddress, isUserAdmin } from 'src/app/helpers/functions';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { ClassService } from 'src/app/core/services/class.service';
import { CallbackSuccessComponent } from '@app-shared/components/callback-success/callback-success.component';
import { cbseRegistration } from '../verify-otp/verify-otp.component';
import { startLearning } from '../target-exam/target-exam.component';
import {SubscriptionService} from '@app-services/subscription/subscription.service';
import {AddToCartComponent} from '@app-modules/feature/subscription/modal/add-to-cart/add-to-cart.component';
import { MyactivityService } from 'src/app/core/services/myactivity.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  loginForm!: FormGroup;
  passwordForm!: FormGroup;
  loginData: any;
  isOtpLogin = true
  show_button = false
  passwordError = false
  UnauthorizedLoginMessage
  forgotPassword = false
  signupForm!: FormGroup
  resetPassword = false
  signupTab: any;
  navExtra: any;
  passwordReseted = false
  showAccountExist: boolean = false;
  showAccountExistLogin: boolean = false;
  disabledGetOtpBtn: boolean = false;
  registrationErrorMessage: any = '';
  mobileNumberValid: boolean = false;
  customValid: boolean = false;
  formatPhoneObject: any;
  @ViewChild(NgxIntlTelInputComponent) telInput: any;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  grades: any;
  urlData: any = {};
  isILITE = false;
  gradesFetched: boolean;
  queryParams: any;
  regLiveclass = false;
  gradeDisabled = false;
  passwordDisable = false;
  isCBSE = false;
  bookCounsel: boolean = false;
  isCallBack:boolean = false;
  cbseRegistration = cbseRegistration;
  startLearning = startLearning;
  exams: any=[];
  liveclass = false;
  subscriptions= false;
  assessmenttests= false;
  rapSubsription= false;
  aitsExam: boolean = false;
  isScoreExam: boolean = false;
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;
  isdCode: string = '+91';
  isdCodes:any = {};
  showInvalidMobileNumber:boolean = false;
  isDynamicRedirection:boolean = false;
  dynamicRedirectionUrl:any;
  isAgreedToTC:boolean = false;
  constructor(
    private fb: FormBuilder,
    public signUpService: SignupService,
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private location: Location,
    private route: ActivatedRoute,
    private targetExamService: BoardsService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService, 
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private gaService: GAnalyticsService,
    private classService: ClassService,
    private SubscriptionService: SubscriptionService,
    private AchievementsService: MyactivityService,
    private http:HttpClient,
  ) {
    let _params = {...(this.activatedRoute.snapshot.queryParams || {})};
    this.queryParams = {..._params};
    if(_params?.utm_source == "BajajFinserv" || (Array.isArray(_params?.utm_source) && _params?.utm_source?.[0] == "BajajFinserv")) {
      sessionStorage.setItem("isFromBajajFinservAppInApp", "true");
    }
    if(_params?.exam?.toUpperCase() == "ILITE" || _params?.exam?.toUpperCase() == "SCORE") {
      this.urlData.exam = 'ilite';
      if(!_params.grade || allowedGrades['infinitylearn']['default'].indexOf(_params.grade?.replace(/[^0-9]/g,'')) < 0) {
        window.location.href = homeRoute+"score";
        return;
      }
      this.urlData.grade = _params.grade?.toLowerCase();
      if(!_params.courses || allowedExamNamesILITE.indexOf(_params.courses?.replace(/[^a-z]/ig, '').toUpperCase()) < 0) {
        window.location.href = homeRoute+"score";
        return;
      }
      this.urlData.courses = _params.courses?.replace(/[^a-z]/ig, '').toUpperCase();

      if(!Array.isArray(_params.date)) {
        _params.date = [_params.date]
      }
      _params.date.forEach(e => {
        if(['18','19','26','2','3'].indexOf(e) < 0) {
          window.location.href = homeRoute+"score";
          return;
        }
      })
      if(!Array.isArray(_params.timeSlot)) {
        _params.timeSlot = [_params.timeSlot]
      }
      this.urlData.timeSlot = _params.timeSlot;
      
      if(typeof _params.origin != 'string' || ['SCORE', 'BHASKAR', 'JAGRAN'].indexOf(_params.origin?.toUpperCase()) < 0){
          _params.origin = (_params.origin || '') + '_invalid-origin';
      };
      this.urlData.origin = _params.origin?.toLowerCase();
      this.urlData.date = _params.date;
      this.isILITE = true;
    } else if(_params?.action?.toUpperCase() == "CALLBACK" || _params?.action?.toUpperCase() == "BOOKCOUNSEL"){
      this.urlData.courses = _params.courses?.replace(/[^a-z]/ig, '').toUpperCase();
      this.urlData.action = _params.action
      this.urlData.page = _params?.page;
      _params?.action?.toUpperCase() == "BOOKCOUNSEL" ? this.bookCounsel = true:  this.isCallBack=true;
    } else if (_params?.exam?.toUpperCase() == "CBSE"){
      this.isCBSE = true;
      this.checkGradeAvailabllility(_params,'');
      this.urlData.grade = _params.grade?.toLowerCase();
      this.urlData.signInparams = _params;
    } else if (_params?.click == "lc_register"){
      if(!_params.courses || allowedExamNamesILITE.indexOf(_params.courses?.replace(/[^a-z]/ig, '').toUpperCase()) < 0) {
        window.location.href = homeRoute;
        return;
      }
      this.urlData.exam = _params.courses?.replace(/[^a-z]/ig, '').toUpperCase();

      if(!_params.grade || allowedGrades['infinitylearn']['default'].indexOf(_params.grade?.replace(/[^0-9]/g,'')) < 0) {
        window.location.href = homeRoute+this.urlData.exam;
        return;
      }
      if(_params.utm_id || _params.campaign_id){
        this.urlData.grade = _params?.grade;
        this.urlData.liveclassId = _params?.id;
        this.urlData.exam = _params.courses?.replace(/[^a-z]/ig, '').toUpperCase();
        this.urlData.page = _params.page;
        this.urlData.utm_id = _params?.utm_id || _params?.campaign_id,
        this.urlData.utm_term = _params?.utm_term,
        this.urlData.utm_source =_params?.utm_source,
        this.urlData.utm_medium = _params?.utm_medium,
        this.urlData.utm_campaign = _params?.utm_medium,
        this.urlData.utm_content = _params?.utm_content
      }
      this.urlData.grade = _params?.grade;
      this.urlData.liveclassId = _params?.id;
      this.urlData.page = _params?.page;
      this.regLiveclass = true;
      this.gradeDisabled = false;
      this.passwordDisable = true;
    } else if(_params?.click == "liveclass"){
      this.liveclass = true;
    }
    else if(_params?.click == "subscriptions"){
      this.subscriptions = true;
    }
    else if(_params?.click == "assessmenttests"){
      this.assessmenttests = true;
    }
    else if(_params?.click == "rapSubscriptions"){
      this.rapSubsription = true;
    }else if(_params?.click == "aits"){
      this.aitsExam = true;
    }else if(_params?.click == "score"){
      this.isScoreExam = true;
    }else if(_params?.click == "dynamic"){
      this.isDynamicRedirection = true;
      this.dynamicRedirectionUrl = _params?.dyanmicUrl;
    }
    else {
      this.urlData = { ...(this.activatedRoute.snapshot.queryParams || {}) };
      console.log(this.urlData);
    }
    
    this.spinner.show();
  }

  gotoTab(tabName) {
    if(this.queryParams?.page =='signup' || this.queryParams?.page =='signin'){
      this.queryParams.page =  tabName;
    }
    if(tabName =='signup'){
      localStorage.setItem('userSignUp','true');
    }else{
      localStorage.setItem('userSignUp','false');
    }
    this.router.navigate([tabName], { queryParams: this.queryParams  });
    
  }

  ngOnInit(): void {
    
    
    this.isdCodes = ISDCodes
    let cookieData = getILCookie('INFINITY_LEARN');
    this.getRefCode();
    let e=JSON.parse(localStorage.getItem('reffCode'));
    console.log(e.referralCode);
    console.log(this.activatedRoute?.snapshot?.routeConfig?.path);
    if(this.activatedRoute?.snapshot?.routeConfig?.path == 'signup'){
        localStorage.setItem('userSignUp','true');
    }else{
      localStorage.setItem('userSignUp','false');
    }
    if(cookieData){
      let data = JSON.parse(cookieData);
      setLoggedInUserData(data, this.userService, this.authService);
      if(data?.scoreData){
        localStorage.setItem('scoreData', JSON.stringify(data?.scoreData));
      }
      setILCookie('INFINITY_LEARN', '', -1);
    }
    let token = localStorage.getItem('token');
    if (token && (!this.isILITE && !this.regLiveclass)) {
      if(this.bookCounsel || this.isCallBack){
        let x = this.urlData?.courses?.replace(/[^a-z]/i,'').toUpperCase();
        let page = x?.indexOf("JEE") > -1 ? "JEE":  x?.indexOf("NEET") > -1 ? "NEET": x?.indexOf("CBSE") > -1 ? this.urlData?.page:  "NA";
        if(this.urlData?.page){
          page = this.urlData?.page;
        }
        let user: any = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)): {};
        this.userService.callTrackingAPI(user?.userId, {data: {...(this.urlData||{}), page}}).subscribe(() => {});
        this.openCallBackDialog(user?.phone);
      }
      if(this.isCBSE){
        let user: any = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)): {};
        let page = this.urlData?.signInparams?.action;
        isUserAdmin(this.userService).then((bool) => {
          if(!bool) {
            this.userService.callTrackingAPI(user?.userId, {data: {...(this.urlData||{}), page}}).subscribe(() => {});
          }
        })
      } if(this.liveclass){
        this.router.navigate(['/dashboard/liveclass']);
        return;
      }
      if(this.subscriptions){
        this.router.navigate(['/subscription/subscriptionPackages']);
        return;
      }
      if(this.assessmenttests){
        this.router.navigate(['/dashboard/assessment']);
        return;
      }
      if(this.aitsExam){
        this.router.navigateByUrl(`dashboard/testlist?examname=${this.queryParams?.examname}&examtype=${this.queryParams?.examtype}`);
        return;
      }
      if(this.isScoreExam){
        this.router.navigate([`/dashboard/testlist/score`]);
        return;
      }
      if(this.isDynamicRedirection){
        this.router.navigateByUrl(`${this.dynamicRedirectionUrl}`);
        this.spinner.hide();
        return;
      }
      if(this.rapSubsription){       
        var param = {
          examName: this.queryParams?.examName,
          year: this.queryParams?.year,
          producttype: 'assessment,liveclasses',
          grade: this.queryParams?.grade,
          pageUrl: "studentPortal_Subscriptions",
          // courseId: this.queryParams?.courseId,
        }
        let grade =this.queryParams?.grade;
        this.SubscriptionService.getPackageDetails(param, grade).subscribe((result: any) => { 
          let packageDeatails = result.find(element=> element.id == this.queryParams?.id);
          this.checkToTheCart(packageDeatails);
        });
      }
      if(this.queryParams?.grade <3){
        this.router.navigate(['/dashboard/assessment']);
      }else{
        this.router.navigate(['/dashboard']);
      }
      return;
    }
    this.navExtra = this.location.getState()
    console.log(this.navExtra)
    if(this.navExtra?.passwordReseted){
      this.passwordReseted = true
      this.isOtpLogin = false
      this.signupTab = false
    }
    let route = this.router.url
    this.signupTab = route?.includes('signup');
    this.createLoginForm();
    this.createPasswordForm();
    this.createSignupForm();
    this.fetchGradesList();
    getIpAddress();
  }
  getRefCode(){
    let refCode=this.activatedRoute.snapshot.queryParams
    console.log({refCode:refCode});
    localStorage.setItem('reffCode',JSON.stringify(refCode));
    this.userService.reffCode=refCode.referralCode;
  }
  checked(grade) {
    return this.reg?.gradeId?.value == grade.gradeId;
  }

  get mob() { return this.loginForm.controls; }
  get pwd() { return this.passwordForm.controls; }
  get reg() { return this.signupForm.controls}

  createSignupForm() {
    this.signupForm = this.fb.group({
      phone: ['', [Validators.pattern(/[26-9][0-9]{9}/)]],
      //Allowing 2 as starting number for load testing
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      whatsappConsent: [true, [Validators.required]],
      gradeId: ['',  [Validators.required]]
    })
  }

  createLoginForm(): void {
    this.loginForm = (this.isdCode == INDIAN_ISD_CODE) ? this.fb.group({
      phone: ['', [Validators.required, Validators.pattern(/[26-9][0-9]{9}/)]]
      //Allowing 2 as starting number for load testing
    }) : this.fb.group({
      phone: ['', [Validators.required, Validators.pattern(/[9][6-9]\d{8}/)]]
    });
  }

  openTermsAndConditionsDialog(): void {
    const config: MatDialogConfig = {
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' }
    };
    const dialogRef = this.dialog.open(TermsAndConditionsDialogComponent, config);
  }

  openPrivacyPolicyDialog(){
    const config: MatDialogConfig = {
      // width: '557px', 
      width: '800px',
      height: '94vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' }
    };
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, config);
  }
  createPasswordForm(): void {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]]
    })
  }

  fetchGradesList() {
    this.targetExamService.fetchGradesList().subscribe((data: any) => {
      this.grades = data;
      if (this.isILITE || this.regLiveclass) {
        this.grades.forEach((ele) => {
          if (ele.name === this.urlData?.grade) {
            this.urlData.gradeObj = ele;
            this.selectedGrade(ele)
          }
        })
      }
      this.gradesFetched = true;
      this.spinner.hide();
    });
  }

  selectedGrade(grade) {
    console.log(grade);
    this.signupForm.get("gradeId").setValue(grade.gradeId);
  }

  async verifyPassword() {
    this.spinner.show()
    clearLocalStorage();
    let page = "WEB_IL_SITE";
    if(this.urlData?.courses) {
      let x = this.urlData?.courses?.replace(/[^a-z]/i,'').toUpperCase(); 
      page = this.isILITE ? this.urlData?.origin?.toUpperCase() : x?.indexOf("JEE") > -1 ? "JEE":  x?.indexOf("NEET") > -1 ? "NEET": "NA";
    }
    if(this.isCBSE){
      page = this.urlData?.signInparams?.action;
    }
    if(this.urlData?.page){
      page = this.urlData?.page;
    }
    let formValue = { 
      phone: this.loginForm.value.phone, 
      password: this.passwordForm.value.password,
      userActivityTrackingDataDto: 
        !this.sendTrackAPIOnSignInOrSignUp 
          ? undefined 
          : {
            "data": {...(this.urlData||{}), page},
            "landingPage": page
          },
    }
    await getIpAddress();
    this.loginService.login(formValue, this.isdCode).subscribe((data: any) => {
      localStorage.setItem('loginCount',data?.userDto?.loginCount);
      if (data && data.accessToken) {
        setLoggedInUserData(data, this.userService, this.authService);
        let _headers = {
          'accesstoken': data.accessToken,
          'studentid': `${formValue.phone}`,
          // 'methodtype': 'RULES'
        };
        if(!this.sendTrackAPIOnSignInOrSignUp) { 
          isUserAdmin(this.userService).then((bool) => {
            if(!bool) {
              this.userService.callTrackingAPI(data?.userDto?.userId, {data: {...(this.urlData||{}), page}}).subscribe(() => {});
            }
          })
        }
        this.classService.syncStudent();
        this.saveAccessToken(_headers,);
        this.gaService.webEngageEvent({
          'event': 'SignIn',
          'phone': this.loginForm.value.phone
        })
        if(this.isCallBack || this.bookCounsel){
          this.openCallBackDialog(data?.userDto?.phone)
        }else if ((this.navExtra?.signInqueryparams?.exam?.toUpperCase() == 'CBSE' && this.navExtra?.signInqueryparams?.pages?.toUpperCase()=='SUBSCRIPTION')||(this.queryParams?.exam?.toUpperCase() == 'CBSE' && this.queryParams?.pages?.toUpperCase()=='SUBSCRIPTION')){
          this.cbseRegistration({gradeObj:this.urlData.gradeObj,...this.urlData, ...this.queryParams})
        }else if(this.regLiveclass){
          this.getExams()
        }
      } else {
        this.UnauthorizedLoginMessage = 'Incorrect Password! Try again'
        this.passwordError = true
      }
    this.spinner.hide()
    },
      (error) => {                                     // on error
        // this.toastr.warning(error.error.message)
        console.log(error);
        this.UnauthorizedLoginMessage = error.error.message
        this.passwordError = true
      this.spinner.hide()

      });
  }

  saveAccessToken(_headers: any, navigateToDashboard?: any): any {
    let route = '/dashboard';
    let userType = this.userService.getUserType()
    if (userType == 2) {
      route += '/liveclass';
    }
    else {
      if (environment?.portal == 'teacher') {
        this.loginService.logoutEvent.emit({ showPopup: true, message: 'Oops!', message2: `Seems like you are not a registerd teacher.` });
        return;
      }
    }
    isUserAdmin(this.userService).then((bool) => {
      if(!bool) {
        this.userService.saveRewardHistory(2).subscribe(res => console.log(res), err => this.spinner.hide());
      }
    })
    let userDetail = this.userService.getMobileAndName()
    if(userDetail?.grade >2){
      this.router.navigate([route])
    }else{
      this.router.navigate([route+'/assessment'])
    }
   setTimeout(() => {
    this.AchievementsService.badgeInvokeSubject.next({});
   }, 1000);
  }

  otpLogin() {
    this.disabledGetOtpBtn = true;
    this.loginData = {
      dialCode: '+91',
      number: Number(this.loginForm.value.phone)
    }
    this.signUpService.verifyPhoneNumber(this.loginData).subscribe((data) => {
      if (data.existingUser === false) {
        this.showAccountExistLogin = true;
      } else if (data.existingUser === true) {
        this.genarateOTP();
        localStorage.setItem('logData', JSON.stringify(this.loginData))
      }
    },
      (error) => {                                     // on error
        // this.errorMessage = error.error.message
      });
  }

  changeLoginType() {
    this.isOtpLogin = !this.isOtpLogin
  }

  togglePass() {
    this.show_button = !this.show_button;
  }

  formSubmit() {
    let data = {
        dialCode: '+91',
        phone: this.signupForm.value.phone,
        firstName: this.signupForm.value.firstName,
        lastName: this.signupForm.value.lastName,
        whatsappConsent: this.signupForm.value.whatsappConsent,
        gradeId: this.signupForm.value.gradeId,
        register: true
    }
    localStorage.setItem('logData', JSON.stringify(data));
    console.log(this.signupForm.value)
    this.signUpService.generateOtp(data, '+91').subscribe((data: any) => {
      if (data) {
        this.router.navigate(['/verify-otp'], { state: { verify: true,register: true, isILITE: this.isILITE,regLiveclass:this.regLiveclass, ...this.urlData, urlData:this.urlData }, queryParams: this.queryParams })
      }
    });
  }

  genarateOTP() {
    const phone: any = { phone: Number(this.loginData.number) };
    this.signUpService.generateOtp(phone, this.loginData.dialCode).subscribe((data: any) => {
      this.gaService.webEngageEvent({
        'event': 'otp count',
        'page_url': window.location.href
      })
      if (this.forgotPassword) {
        this.gaService.webEngageEvent({
          'event': 'Forgot password',
          'page_url': window.location.href
        })
        this.router.navigateByUrl('/verify-otp', { state: {verify: true, passwordReset: true } })
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            verify: true, isILITE: this.isILITE,regLiveclass:this.regLiveclass, ...this.urlData, urlData: this.urlData,
          },
          queryParams: this.queryParams
        };
        this.router.navigate(['/verify-otp'], navigationExtras);
      }
    });
  }

  verifyPhoneNumber() {
    this.loginData = {
      dialCode: '+91',
      number: Number(this.signupForm.value.phone)
    }
    if(/[6-9][0-9]{9}/.test(this.signupForm.get('phone').value)){
      this.signUpService.verifyPhoneNumber(this.loginData).subscribe((data) => {
        if (data.existingUser === false) {
          this.showAccountExist = false;
        } else if (data.existingUser === true) {
          this.showAccountExist = true;
        }
      })
    }
    
  }

  verifyPhoneNumberLogin() {
    // this.asterickPhoneFormat();
    const phoneNumber = this.loginForm.value.phone.toString()
    if(this.isdCode == '+977') {
      // if(phoneNumber?.length > 9) {
      //   const isNepalCode = this.regExpService.isValidNepalIsdCode(phoneNumber);
      //   this.showInvalidMobileNumber = isNepalCode ? false : true;
      // }
      return;
    }
    if (phoneNumber?.length > 5) {
      Array(phoneNumber?.length).fill('*').join('')
    }
    this.loginData = {
      dialCode: '+91',
      number: Number(this.loginForm.value.phone)
    }
    if(this.loginForm.valid){
      this.signUpService.verifyPhoneNumber(this.loginData).subscribe((data) => {
        if (data.existingUser === false) {
          this.showAccountExistLogin = true;
        } else if (data.existingUser === true) {
          this.showAccountExistLogin = false;
        }
      })
    }
    
  }

  openCallBackDialog(phone){
    let titleText;
    this.isCallBack ? titleText = 'Your request for a call back has been sent.' : titleText = 'Your request for free counselling session has been sent.'
    const config: MatDialogConfig = {
      width: '400px',
      height: '290px',
      data: {
        phone: phone,
        title: titleText
      },
    };
    let dialogRef = this.dialog.open(CallbackSuccessComponent, config)
    dialogRef.afterClosed().subscribe((res) => {
      this.router.navigate(['/dashboard'])
    })
  }
  checkGradeAvailabllility(_params,type){
    if(!_params.grade || curTenantDetails['allowedGrades'].indexOf(_params.grade?.replace(/[^0-9]/g,'')) < 3) {
      window.location.href = homeRoute+type;
      return;
    }
  }

  getExams(){
    this.targetExamService.fetchTargetExamList().subscribe((data: any) => {
      this.exams = data;
      let selectedExams = [];
        let exam = this.isILITE ? this.urlData?.courses : this.urlData?.exam
        let index = this.exams.findIndex((ind) =>
          ind.name.replace(/[^a-z]/ig,'').toUpperCase() == exam
        );
        if (index > -1) {
          selectedExams.push(this.exams[index]);
          this.startLearning({selectedExams, isILITE: this.isILITE, regLiveClass:this.regLiveclass, grade: this.urlData?.gradeObj, ILITEData: this?.urlData})
        }      
    });
  }

  routeToplanPage(pack: any) {
    this.SubscriptionService.subscriptionSelectedData.liveclass_courseID =
      pack?.packagesCourseDtoList?.[0]?.courseId ? (pack?.courseId == 1 ? null : pack?.courseId) : null;
    pack.packageName = pack?.name;
    pack.amount = pack?.maxValue;
    pack.productComponentList = pack?.packageSubscriptionList?.[0]?.componentsList;
    pack.validDate = pack?.packageValidity;
    this.router.navigate(['../subscription/proceed-to-payment'], {
      state: { ...pack },
    });

    let arr = { "selectedPackage": pack };
    localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(arr));
    this.spinner.hide();
  }

  checkToTheCart(pack) {
    localStorage.removeItem('logo-popup');
    if (pack) {
      this.spinner.show()
      var userDetail = localStorage.getItem('mobile_and_name') ? JSON.parse(localStorage.getItem('mobile_and_name')) : {}
      let body = {
        grade: userDetail?.grade,
        userId: userDetail?.userId
      }
      this.SubscriptionService.getAllCartItems(body).subscribe((resp: any) => {
        this.spinner.hide()
        if (resp?.length) {
          // productId 3 - ultimate  // productId 1 - Pro Packages  //7  score Package // productId 6 - starter
          var checkIspackageAlreadyadded;
          if (pack?.productId == 1) {
            checkIspackageAlreadyadded = resp?.findIndex(v => v?.subscription?.id == pack?.packageSubscriptionList?.filter((subId) => v?.subscription?.id)[0]?.id)
          } else {
            checkIspackageAlreadyadded = resp?.findIndex(v => v?.subscription?.id == pack?.packageSubscriptionDto?.id)
          }
          if ([3, 1, 8].indexOf(pack?.productId) !== -1 && checkIspackageAlreadyadded !== -1) {
            this.openAddToCartDialog(pack);
          } else if ((pack?.productId == 7 || pack?.productId == 6 || pack?.productId == 2) && checkIspackageAlreadyadded !== -1) {
            let scoreIdList = [];
            resp?.filter((ele) => ele?.subscription?.packages?.id == pack?.id)?.forEach((val) => scoreIdList?.push(val?.scoreId));
            pack['scoreIdList'] = scoreIdList;
            this.openAddToCartDialog(pack);
          }
          else {
            this.routeToplanPage(pack);
          }
        } else {
          this.routeToplanPage(pack);
        }
      }, ((err) => {
        this.spinner.hide()
      }))
    }
  }

  openAddToCartDialog(pack_data) {
    this.dialog.open(AddToCartComponent, { width: "445px", panelClass: 'SUBCRP-addtocart-modal', data: pack_data });
  }

  onISDChange(value) {
    this.isdCode = value;
    // this.isOtpLogin = (value == INDIAN_ISD_CODE) ? true : false;
    this.loginForm = null;
    this.createLoginForm();
  }

  hideOtpSignIn(){
    const flag =  ((this.isdCode == INDIAN_ISD_CODE) && (!this.isOtpLogin));
    return flag;
  }


  // asterickPhoneFormat() {
  //   console.log(this.loginForm.value.phone);
  //   const dummyEl = document.querySelector('.dummyPhone');
  //   let dummyPhone = this.loginForm.value.phone.toString();
  //   dummyEl.innerHTML = dummyPhone;
  //   if (this.loginForm.value.phone.toString().length > 5 || this.loginForm.value.phone.toString().length >= 10) {
  //     let cloneDigit = Array(this.loginForm.value.phone.toString().length - 5).fill('x').join('');
  //     let showDummy = dummyPhone.slice(0, ( 5 - this.loginForm.value.phone.toString().length)) + cloneDigit;
  //     dummyEl.innerHTML = showDummy;
  //   }
  // }

  // restToDummyPwd() {
  //   console.log(this.passwordForm.value.password);
  //   const dummyPWD = document.querySelector('.dummyPwd');
  //   let dummyPassword = Array(this.passwordForm.value.password.toString().length).fill('*').join('')
  //   dummyPWD.innerHTML = dummyPassword;
  // }




}
